<template>
  <div
    :class="[
      'base__btn',
      size,
      type == 'light' && clickable ? 'base__btn--clickable-1' : 'disabled',
      type == 'borderLight' ? 'base__btn--clickable-4' : '',
      type == 'normal' && clickable ? 'base__btn--clickable-2' : 'disabled',
      type == 'normalLight' && clickable
        ? 'base__btn--clickable-3'
        : 'disabled',
    ]"
    @click="clickHandle"
  >
    <span class="content">{{ value }}</span>
  </div>
</template>
<script>
export default {
  name: "weButton",
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    clickable: {
      type: Boolean,
      required: false,
      default: true,
    },
    size: {
      type: String,
    },
  },
  mounted() {},
  methods: {
    clickHandle() {
      this.$emit("click", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.base__btn {
  display: inline-block;
  text-align: center;
  padding: 1px;
  border-radius: 26px;
  font-weight: 500;
  background: #fff;
  font-family: PingFangHK-Medium, PingFangHK;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}
.small {
  min-width: 86px;
  height: 34px;
  padding: 0 15px;
  line-height: 34px;
  font-size: 14px;
}
.medium {
  width: 160px;
  line-height: 44px;
  font-size: 16px;
}
.large {
  width: 206px;
  line-height: 52px;
  font-size: 22px;
}
.disabled {
  background: #d6dbe0;
  border-color: #d6dbe0;
  color: #666666;
  cursor: not-allowed;
}
.base__btn--clickable-1 {
  position: relative;
  background: linear-gradient(150deg, #50e3c2, #003aff);
  cursor: pointer;
  color: #3f69f9;
  border-radius: 27px;
  &:hover {
    box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.1);
  }
  .content {
    position: absolute;
    display: block;
    left: 1px;
    bottom: 1px;
    right: 1px;
    top: 1px;
    margin: 0px;
    background: #fff;
    border-radius: 26px;
  }
  &:after {
    content: "";
    display: inline-block;
    clear: both;
    height: 0;
    width: 100%;
  }
}
.base__btn--clickable-2 {
  background: #3f69f9;
  color: #fff;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 5px 7px 0px rgba(63, 105, 249, 0.23);
  }
}
.base__btn--clickable-3 {
  background: #3f69f9;
  color: #fff;
  cursor: pointer;
  &:hover {
    background-color: #5c86ff;
  }
}
.base__btn--clickable-4 {
  color: #3f69f9;
  height: 32px;
  line-height: 32px;
  border: 1px solid #3f69f9;
  background: #fff;
  cursor: pointer;
  &:hover {
    background: #3f69f9;
    color: #fff;
    box-shadow: 0px 4px 6px 0px rgba(63, 105, 249, 0.4);
  }
}
</style>
